import { useId } from 'react'

import { useGuideTour } from '../provider/guideTourContext'
import { hasGuideTourStepTarget } from '../utils/targets'
import * as S from './styles'

export const GuideTourOverlay = () => {
  const {
    state,
    currentStep,
    dismiss,
    targetBounds,
    isCurrentStepReady,
    isInModalLayer,
    isSkippedStepsSummaryActive,
  } = useGuideTour()
  const maskId = useId()
  const hasTarget = hasGuideTourStepTarget(currentStep)
  const isActive = state.status === 'active'
  const isSummaryOnly = isSkippedStepsSummaryActive

  if (!isActive || (!isSummaryOnly && !isCurrentStepReady)) {
    return null
  }

  if (!isSummaryOnly && hasTarget && !targetBounds) {
    return null
  }

  return (
    <S.Overlay
      data-testid="guide-tour-overlay"
      elevated={isInModalLayer}
      aria-hidden
      onClick={dismiss}
    >
      <S.OverlaySvg>
        {hasTarget && targetBounds ? (
          <>
            <defs>
              <mask id={maskId}>
                <rect width="100%" height="100%" fill="white" />
                <rect
                  x={targetBounds.left}
                  y={targetBounds.top}
                  width={targetBounds.width}
                  height={targetBounds.height}
                  rx={12}
                  fill="black"
                />
              </mask>
            </defs>
            <rect
              width="100%"
              height="100%"
              fill="rgba(0, 0, 0, 0.65)"
              mask={`url(#${maskId})`}
            />
          </>
        ) : (
          <rect width="100%" height="100%" fill="rgba(0, 0, 0, 0.65)" />
        )}
      </S.OverlaySvg>
    </S.Overlay>
  )
}
